import { Col, Form, Input } from "antd";
import React from "react";
import { langCheck } from "Pub/js/utils";
import Notice from "Components/Notice";
import platform from "Pub/js/platform";
const { NCSelect, NCRadio, NCFormControl } = platform.base;
const FormItem = Form.Item;
const RadioGroup = NCRadio.NCRadioGroup;
/**
 * 创建表单
 * @param {*} propsData
 * @param {*} DOMDATA
 * @param {*} nodeData
 */
export const createForm = (DOMDATA, propsData) => {
    const children = [];
    DOMDATA &&
        DOMDATA.map((item, index) => {
            let { lable, md = 24, lg = 12, xl = 8 } = item;
            if (!item.hidden) {
                children.push(
                    <Col md={md} lg={lg} xl={xl} key={index} fieldid={item.code}>
                        {createFormItem(propsData, item)}
                    </Col>
                );
            }
        });

    return children.filter(item => {
        return item.props.children;
    });
};
/**
 * 创建表单
 * @param {*} props
 * @param {*} itemInfo
 */
const createFormItem = (props, itemInfo) => {
    let nodeData = props.zoneDatas;
    let { json, zoneFormData } = props;
    const { getFieldDecorator, getFieldsValue } = props.form;
    let { lable, type, code, required, check, search, disabled, maxlength } = itemInfo;
    const formItemChange = (e) => {
        let formData = { ...zoneFormData };
        let val = ['string', 'boolean'].includes(typeof e) ? e : e.target.value;
        let newFormData = { ...formData, ...{ [code]: val } };
        props.setZoneDataFun(newFormData);
        //改变表头重新渲染areaList
        if (code === 'headcode') {
            props.updateAreaList(props.areaList);
        }
    }
    switch (type) {
        case "select":
            if (nodeData.areaList && nodeData.areaList.length > 0) {
                nodeData.areaList.map(item => {
                    if (nodeData[code] === item.code && item.areatype === "0") {
                        Notice({
                            status: "error",
                            msg: langCheck("102202APP-000000", "pages", json)
                        }); /* 国际化处理： 数据有误*/
                        return;
                    }
                });
            }
            return (
                <FormItem label={lable}>
                    {getFieldDecorator(code, {
                        initialValue: zoneFormData[code] ? zoneFormData[code] + "" : "",
                        rules: [
                            {
                                required: required,
                                message: langCheck(
                                    "102202APP-000001",
                                    "pages",
                                    json
                                ) /* 国际化处理： 此字段为必输项或请补充此表单区编码！*/
                            },
                            {
                                validator: check ? check : null
                            }
                        ]
                    })(
                        <NCSelect
                            showClear={false}
                            fieldid={code}
                            onChange={formItemChange}>{itemInfo.options}
                        </NCSelect>
                    )}
                </FormItem>
            );
        case "radio":
            let radioInitialValue = nodeData[code] ? nodeData[code] : false;
            return (
                <FormItem label={lable}>
                    {getFieldDecorator(code, {
                        initialValue: radioInitialValue,
                        rules: [
                            {
                                required: required
                            },
                            {
                                type: "boolean",
                                validator: check ? check : null
                            }
                        ]
                    })(
                        <RadioGroup
                            selectedValue={props.zoneFormData[code]}
                            onChange={formItemChange}
                        >
                            <NCRadio value={true}>
                                {langCheck(
                                    "102202APP-000069",
                                    "pages",
                                    json
                                ) /* 国际化处理：是*/}
                            </NCRadio>
                            <NCRadio value={false}>
                                {langCheck(
                                    "102202APP-000070",
                                    "pages",
                                    json
                                ) /* 国际化处理：否*/}
                            </NCRadio>
                        </RadioGroup>
                    )}
                </FormItem>
            );
        default:
            return (
                <FormItem label={lable}>
                    {
                        disabled ? <span>{nodeData[code]}</span> :
                            getFieldDecorator(code, {
                                initialValue: nodeData[code] ? nodeData[code] + "" : "",
                                rules: [
                                    {
                                        required: required,
                                        message: `${langCheck(
                                            "102202APP-000002",
                                            "pages",
                                            json
                                        )}${lable}` /* 国际化处理： 请输入*/
                                    },
                                    {
                                        validator: check ? check : null
                                    }
                                ]
                            })(
                                // <Input autoComplete="off" onChange={formItemChange} />
                                <NCFormControl isCheckChinese maxlength={maxlength}  onChange={formItemChange} />
                            )
                    }
                </FormItem>
            );
    }
};
